<template>
  <div>
    <div class="page-main has-bottom">
      <page-title :back="true" @goback="goback" />
      <page-card v-loading="loading" style="margin-bottom: 32px">
        <template slot="header"> Well Information </template>
        <div slot="body">
          <wellComp :page-data="pageData" :well-index="1" />
        </div>
      </page-card>
    </div>

    <page-bottom>
      <template>
        <div class="page-btns">
          <el-button type="primary" @click="handleReject()">Reject</el-button>
          <el-button type="primary" @click="handleApproval()">Approval</el-button>
          <!-- <loading-btn
            type="primary"
            label="Approval"
            @clickHandle="approval($event, 1)"
          /> -->
        </div>
      </template>
    </page-bottom>
    <editInformationSuccess
      ref="editInformationSuccess"
      :no-tip="true"
      msg="Approved completed!"
      @close="goback"
    />

    <el-dialog :title="title" :visible.sync="open" width="6rem">
      <p class="des">
        <svg-icon icon-class="warning" /> &nbsp;&nbsp;Are you sure to {{ title.toLowerCase() }} the
        application?
      </p>
      <br>
      <el-form v-if="title === 'Reject'" ref="form" :model="form" label-position="top">
        <el-form-item
          label="Approval Instructions"
          prop="refusalReason"
          :rules="[{ required: true, message: 'Plase fill in', trigger: 'blur' }]"
        >
          <el-input
            v-model="form.refusalReason"
            type="textarea"
            autocomplete="off"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">Cancel</el-button>
        <loading-btn
          type="primary"
          label="Confirm"
          @clickHandle="handleEvent($event, 3)"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* global web3 */
import { updateWellStatus } from '@/api/manager.js'
import { wellList } from '@/api/well.js'
import wellComp from '@/views/wellManage/myWells/wellInfo.vue'
import editInformationSuccess from '@/views/authentication/editInformationSuccess.vue'
export default {
  components: {
    wellComp,
    editInformationSuccess
  },
  data() {
    return {
      loading: false,
      pageData: {},
      wellList: [],
      title: '',
      open: false,
      form: {
        refusalReason: undefined
      },
      producerContract: undefined,
      producerAddress: undefined,
      gasContract: undefined,
      gasAddress: undefined
    }
  },
  computed: {},
  created() {
    this.getInfo()
    this.getAbi('OilProducer').then((res) => {
      this.producerContract = new web3.eth.Contract(res.data.abi, res.data.address)
      this.producerAddress = res.data.address
    })
    this.getAbi('GasProducer').then((res) => {
      this.gasContract = new web3.eth.Contract(res.data.abi, res.data.address)
      this.gasAddress = res.data.address
    })
  },
  methods: {
    getInfo() {
      this.loading = true
      const param = {
        wellID: this.$route.query.wellID
      }
      wellList(param)
        .then((res) => {
          const resData = res.result || {}
          this.pageData = resData
          // this.wellList = resData.data.wellData ? [resData.data.wellData] : [resData.data];
          // this.wellList[0].sulphur = this.wellList[0].sulphur / 100;
          // this.wellList[0].APIGravity = this.wellList[0].APIGravity / 100;
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleReject() {
      this.title = 'Reject'
      this.open = true
    },
    handleApproval() {
      this.title = 'Approval'
      this.open = true
    },
    handleCancel() {
      if (this.$refs.form) {
        this.$refs['form'].resetFields()
      }
      this.open = false
    },
    async handleEvent(btn) {
      this.btn = btn
      if (this.title === 'Reject') {
        try {
          await this.rejectApi(btn)
          if (this.pageData.type === 'OIL') {
            await this.submitContract(this.producerContract, this.producerAddress, 2)
          } else {
            await this.submitContract(this.gasContract, this.gasAddress, 2)
          }
          this.btn && this.btn.closeLoad()
          this.$message.success('Rejected successfully!')
          this.goback()
        } catch {
          this.btn && this.btn.closeLoad()
        }
      } else {
        try {
          console.log(this.pageData.type)
          await this.approvalApi()
          if (this.pageData.type === 'OIL') {
            console.log(1)
            await this.submitContract(this.producerContract, this.producerAddress, 1)
          } else {
            console.log(2)
            await this.submitContract(this.gasContract, this.gasAddress, 1)
          }
          this.btn && this.btn.closeLoad()
          this.$message.success('Approved successfully!')
          this.goback()
        } catch {
          this.btn && this.btn.closeLoad()
        }
      }
    },
    rejectApi() {
      return new Promise((reslove, reject) => {
        const param = {
          status: 3,
          wellID: this.$route.query.wellID,
          refusalReason: this.form.refusalReason
        }
        updateWellStatus(param)
          .then(() => {
            reslove()
          })
          .catch(() => {
            this.btn && this.btn.closeLoad()
            reject()
          })
      })
    },
    approvalApi() {
      return new Promise((resolve, reject) => {
        const param = {
          status: 1,
          wellID: this.$route.query.wellID
        }
        updateWellStatus(param)
          .then(() => {
            resolve()
          })
          .catch(() => {
            reject()
          })
      })
    },
    submitContract(contract, address, ProducerStatus) {
      return new Promise((resolve, reject) => {
        const uniqueId = web3.utils.padRight(
          web3.utils.toHex(this.$route.query.wellID),
          64
        )
        const tx_builder = contract.methods['setProducerStatus'](
          uniqueId,
          ProducerStatus
        )
        const encoded_tx = tx_builder.encodeABI()

        const json = {
          gas: this.$store.getters.gas,
          from: this.$store.getters.metaMaskObj.account,
          to: address,
          value: 0,
          data: encoded_tx
        }
        web3.eth
          .sendTransaction(json)
          .then(() => {
            resolve()
          })
          .catch((error) => {
            reject()
            this.$message.error('operation failed')
            console.error(error)
          })
      })
    },
    goback() {
      this.$router.push('/wellManagement/approve')
    }
  }
}
</script>
<style scoped lang="scss">
.des {
  font-size: 0.22rem;
  font-family: Roboto-Medium, Roboto;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  line-height: 0.32rem;
}
</style>
